<div class="app-wrapper">
  <app-navbar></app-navbar>

  <main class="main-content">
    <!-- Dashboard quando utente è loggato e siamo sulla route principale -->
    @if (isAuthenticated() && showHome()) {
      <app-home></app-home>
    } @else if(!isAuthenticated()) {
      <!-- Home pubblica quando utente NON è loggato -->
      <app-landing></app-landing>
    } @else {
      <!-- Contenuto area applicativa per le altre route -->
      <section class="content-section">
        <div class="container router-content">
          <router-outlet></router-outlet>
        </div>
      </section>
    }
  </main>

  <!-- <app-footer></app-footer> -->
</div>

<!-- Toast globale per notifiche -->
<p-toast position="top-right"></p-toast>


